import { useState } from 'react'
import { useDispatch } from 'react-redux'
import styled from 'styled-components'

import { DrawerBodyWrapper, DrawerFooterWrapper, TOAST_TYPE } from '@base'
import { Button, Select, Textarea } from '@baseV2'
import { strings, TENDERBOOK_FOLLOW_UP_STATUS_OPTIONS } from '@constants'
import { showLoader, showToast } from '@data/state/action'
import { toggleDrawer } from '@data/state/action/root'
import { Spacings } from '@styles'

const Field = styled.div`
	margin-bottom: ${Spacings.SPACING_4B};
`

// Shared body for the user and lead remarks drawers; `save` receives the payload and returns a promise.
const FollowUpRemarks = ({ data, update, save }) => {
	const dispatch = useDispatch()

	const [followUpStatus, setFollowUpStatus] = useState(
		() => TENDERBOOK_FOLLOW_UP_STATUS_OPTIONS.find((option) => option.id === data?.follow_up_status) ?? {}
	)
	const [comments, setComments] = useState(data?.comments ?? '')

	const submitHandler = () => {
		const payload = {
			follow_up_status: followUpStatus?.id ?? null,
			comments: comments.trim(),
		}

		dispatch(showLoader(true))
		save(payload)
			.then(() => {
				dispatch(showToast(true, 'Remarks updated', { type: TOAST_TYPE.SUCCESS }))
				update?.()
				dispatch(toggleDrawer(false))
			})
			.catch((error) => {
				dispatch(showToast(true, error?.response?.data?.message ?? 'Failed to update remarks', { type: TOAST_TYPE.ERROR }))
			})
			.finally(() => {
				dispatch(showLoader(false))
			})
	}

	return (
		<>
			<DrawerBodyWrapper>
				<Field>
					<Select
						id='follow_up_status'
						label='Follow up status'
						placeholder='Select follow up status'
						data={TENDERBOOK_FOLLOW_UP_STATUS_OPTIONS}
						primaryKey='id'
						displayKey='label'
						value={followUpStatus}
						onChange={setFollowUpStatus}
					/>
				</Field>

				<Field>
					<Textarea
						id='comments'
						label='Comments'
						placeholder='Add comments'
						rows={5}
						value={comments}
						onChange={(e) => setComments(e.target.value)}
					/>
				</Field>
			</DrawerBodyWrapper>
			<DrawerFooterWrapper>
				<Button onClick={submitHandler} disabled={!followUpStatus?.id}>
					{strings('submit')}
				</Button>
			</DrawerFooterWrapper>
		</>
	)
}

export default FollowUpRemarks
